import React from "react";
import {AuthContext} from "../auth-provider";

/**
 * useAuthUser returns the current authentication state from a context
 *
 * @returns {{isError: boolean, isAuthenticated: *, isPending: boolean, isSuccess: boolean}}
 */
function useAuthUser() {

    const state = React.useContext(AuthContext)
    const isPending = state.status === 'pending'
    const isError = state.status === 'error'
    const isSuccess = state.status === 'success'
    const isAuthenticated = state.user && isSuccess
    return {
        ...state,
        isPending,
        isError,
        isSuccess,
        isAuthenticated,
    }
}

export default useAuthUser;